import { render, staticRenderFns } from "./Whatsappv1BotStateChanged.vue?vue&type=template&id=3b157f1c&scoped=true"
import script from "./Whatsappv1BotStateChanged.vue?vue&type=script&lang=js"
export * from "./Whatsappv1BotStateChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b157f1c",
  null
  
)

export default component.exports